import styled from 'styled-components';

const Badge = styled.span`
  color: ${({ hasErrors = false }) => (hasErrors ? 'yellow' : 'white')};
`;

export default Badge;
